if(!customElements.get('funto-guide-library')){
 customElements.define('funto-guide-library',class extends HTMLElement{
  connectedCallback(){
   this.grid=this.querySelector('[data-guide-grid]');
   this.input=this.querySelector('[data-guide-search]');
   this.empty=this.querySelector('[data-guide-empty]');
   if(!this.grid||!this.input)return;
   this.cards=Array.from(this.grid.querySelectorAll(':scope > [data-guide-card]'));
   this.available=this.cards.filter(card=>!card.hidden);
   this.index=new Map(this.available.map(card=>[card,`${card.textContent} ${card.dataset.guideKeywords}`.normalize('NFKC').toLowerCase()]));
   this.onInput=()=>this.filter();
   this.input.addEventListener('input',this.onInput);
   this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.layout());};
   this.observer=new ResizeObserver(this.schedule);
   this.observer.observe(this.grid);
   this.cards.forEach(card=>this.observer.observe(card));
   this.filter();
  }
  filter(){
   const terms=this.input.value.normalize('NFKC').toLowerCase().trim().split(/\s+/).filter(Boolean);
   let count=0;
   this.available.forEach(card=>{
    card.hidden=!terms.every(term=>this.index.get(card).includes(term));
    const more=card.querySelector('.funto-guide-products-more');
    if(more){
     const match=terms.length>0&&Array.from(more.querySelectorAll('a')).some(link=>terms.every(term=>`${link.textContent} ${link.title}`.normalize('NFKC').toLowerCase().includes(term)));
     if(match){more.open=true;more.dataset.searchOpened='true';}
     else if(more.dataset.searchOpened){more.open=false;delete more.dataset.searchOpened;}
    }
    if(!card.hidden)count++;
    else card.querySelectorAll('iframe').forEach(frame=>frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),'https://www.youtube-nocookie.com'));
   });
   this.empty.hidden=count!==0;
   this.schedule();
  }
  layout(){
   if(matchMedia('(max-width:749px)').matches){this.grid.removeAttribute('data-ready');this.grid.style.height='';return;}
   const gap=parseFloat(getComputedStyle(this.grid).columnGap)||32;
   this.grid.setAttribute('data-ready','');
   const heights=[0,0];
   this.cards.filter(card=>!card.hidden).forEach(card=>{
    const column=heights[0]<=heights[1]?0:1;
    card.style.left=`${column*(card.offsetWidth+gap)}px`;
    card.style.top=`${heights[column]}px`;
    heights[column]+=card.offsetHeight+gap;
   });
   this.grid.style.height=`${Math.max(0,...heights)- (Math.max(...heights)>0?gap:0)}px`;
  }
  disconnectedCallback(){this.observer?.disconnect();this.input?.removeEventListener('input',this.onInput);cancelAnimationFrame(this.frame);}
 });
}

